module.exports = __webpack_public_path__ + "static/media/truck_8t.33f5d81b.svg";